var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoicepending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.285,
    height: 22.831,
    viewBox: "0 0 18.285 22.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39487",
    "data-name": "Group 39487",
    transform: "translate(0.05 0.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27776",
    "data-name": "Path 27776",
    d: "M19.273,35.458H17v2.273H35.184V35.458H32.911v-3.88L27.7,26.365l5.212-5.212v-3.88h2.273V15H17v2.273h2.273v3.88l5.212,5.212-5.212,5.212Zm2.273-15.245V17.273h9.092v2.939l-4.546,4.546Zm4.546,7.76,4.546,4.546v2.939H21.546V32.518Z",
    transform: "translate(-17 -15)",
    fill: "#4b96cd",
    stroke: "#4a96cc",
    strokeWidth: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicepending);
export default __webpack_public_path__ + "static/media/invoicepending.cfef741528e6cc2db4c11b43ded2ed02.svg";
export { ForwardRef as ReactComponent };